import React from 'react';
import { useTranslator } from 'tradera/lang/translate';

export const TakeawayOptionsDisplay = ({ options, onlyTakeaway }) => {
    const { t } = useTranslator();
    const getLocationText = (option) =>
        `${option.location.city}, ${option.location.country}`;
    return options.map((option, idx) => (
        <div key={`${option.displayText}${idx}`} className={`d-flex mb-1`}>
            <strong>
                {onlyTakeaway ? t('vip_shipping_pickup') : option.displayText}
            </strong>
            <div className="ml-auto">
                {option.location &&
                    (option.location.mapUrl ? (
                        <a
                            href={option.location.mapUrl}
                            target="_blank"
                            rel="noreferrer nofollow">
                            {getLocationText(option)}
                        </a>
                    ) : (
                        getLocationText(option)
                    ))}
            </div>
        </div>
    ));
};
